import React from 'react';
import './TopicsSection.css';

const topics = [
    "Additive Manufacturing & Application",
    "Metamaterials and Origami Structures",
    "Application of Artificial Intelligence",
    "Multiscale Analysis",
    "Applied Computational Mechanics",
    "Multi-hazard Engineering",
    "Big Data Analytics in Infrastructures",
    "Multifunctional Materials & Structures",
    "Bridge Engineering",
    "Nanoscale Mechanics",
    "Carbon-neutral Materials",
    "Nonlinear Structures",
    "Circular and Sustainable Structures/ Buildings",
    "Non-destructive Testing",
    "Coastal & Offshore Structures",
    "Performance-based Design",
    "Composite Materials & Structures",
    "Plates & Shell Structures",
    "Concrete & Masonry Structures",
    "Prefabrication & Modular Construction of Engineering Structures",
    "Construction Techniques",
    "Resilient Structures",
    "Data-driven Analysis Methods",
    "Robustness & Progressive Collapse",
    "Deployable & Inflatable Structures",
    "Smart Structures & Control",
    "Digital Twin and Building Information Modelling (BIM)",
    "Soil-structure Interaction",
    "Disaster Prevention",
    "Standards & Code of Practice",
    "Digital Design Methods",
    "Structural Stability",
    "Earthquake Engineering",
    "Structural Dynamics",
    "Environmentally Responsive Structures",
    "Structure-fluid-soil Interaction",
    "Experimental Methods",
    "Structural Health Monitoring",
    "Fire Engineering",
    "Structural & Solid Mechanics",
    "Floating Structures",
    "Structural Reliability/Safety",
    "Fatigue & Fracture",
    "Structural Optimization",
    "Innovative Structures",
    "Steel Structures",
    "Impact & Blast Engineering",
    "Tall Buildings",
    "Infrastructure Engineering",
    "Timber Engineering",
    "Life Circle Assessment/Integrity",
    "Underground Structures",
    "Vibration Testing of Structures",
    "Value Engineering",
    "Maintenance, Repairs & Strengthening of Structures",
    "Wind Engineering",
    "Modelling & Simulation",
    'Offshore Structures'
  ];

const TopicsSection = () => {
  return (
    <section className="topics section fade-in-up" id="topics">
      <div className="container">
        <h2 className="section-title" id="topic-title">Conference Topics</h2>
        <p className="topics-subtitle">ICES2026 covers the following key topics (but not limited to):</p>
        <div className="topics-grid">
          {topics.map((topic, i) => (
            <div key={i} className={`topic-row ${i % 4 < 2 ? 'alt' : ''}`}>{topic}</div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TopicsSection;
